<template>
  <div
    id="sidebar-logo-container"
    class="sidebar-logo-container"
    :class="{'collapse':collapse}"
  >
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img
          v-if="logo"
          :src="privateConfig.privateLoginIconUrl"
          class="sidebar-logo"
        />
        <h1
          v-else
          class="sidebar-title"
        >{{ projectItem.projectName }}</h1>
      </router-link>
      <router-link
        v-else
        key="expand"
        class="sidebar-logo-link"
        to="/"
      >
        <img
          v-if="logo"
          :src="privateConfig.privateLoginIconUrl"
          class="sidebar-logo"
        />
        <h1
          v-if="projectItem.projectName.length<=20"
          class="sidebar-title"
        >{{ projectItem.projectName }}</h1>
        <el-tooltip
          v-else
          effect="dark"
          :content="projectItem.projectName"
          placement="right"
        >
          <h1 class="sidebar-title">{{ projectItem.projectName }}</h1>
        </el-tooltip>

      </router-link>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'Vue Element Admin',
      logo: require('../../../assets/images/logo.png')
    }
  },
  computed: {

    ...mapState({
      projectItem: state => state.user.projectItem,
      privateConfig: state => state.user.privateConfig
    })
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

#sidebar-logo-container{
  .sidebar-logo-link{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    .sidebar-title{
      max-width: 150px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;

    }
  }
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
      flex-shrink: 0;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 1;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
